import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import ScrollToTop from "./ScrollToTop";
import MiniTrustStrip from "./MiniTrustStrip";

export default function SiteLayout() {
  return (
    <div className="min-h-screen bg-[#FAF5EC] text-[#1C110C] relative overflow-x-hidden pb-14 sm:pb-0">
      <ScrollToTop />
      <Header />
      <main className="pt-20">
        <Outlet />
      </main>
      <MiniTrustStrip />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
